import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

// 查询公告信息
export function getContentDemand(param) {
  const url = handlerGetUrlParams('/bus/demands/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 审核公告
export function auditContentDemand(ids) {
  return request({
    url: `/bus/contents/demands/audit`,
    method: 'PUT',
    data: ids
  })
}
